module.exports = __webpack_public_path__ + "img/banner-princiapal.142f48ca.png";